import clsx from 'clsx';
import { ChangeEvent } from 'react';
import { FormCheck } from 'react-bootstrap';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';
import { PaymentCellEditProps } from './types';

const IsOwnExpensesCell = ({
	rowData,
	onCellEdit,
	rowIndex,
	cellIndex,
	editable,
	selectedCell,
	setSelectedCell,
}: PaymentCellEditProps) => {
	const CELL_ID = `${rowData.id}${cellIndex}`;
	
	if (!rowData?.id) return <></>;
	
	return (
		<TableCustomCell
			className={clsx('spaces', {
				'focus-cell': CELL_ID === selectedCell,
				'min-h-28': rowData?.id,
			})}
			data={
				<FormCheck
					type="checkbox"
					checked={rowData?.isOwnExpenses}
					className={clsx('d-flex justify-content-center form-check spaces h-28', {
						'pe-none': !editable,
					})}
					onChange={(e: ChangeEvent<HTMLInputElement>) => {
						setSelectedCell(CELL_ID);
						onCellEdit(
							rowData,
							e.target.checked,
							rowIndex,
							'isOwnExpenses',
							rowData.isOwnExpenses
						);
					}}
					disabled={!editable}
				/>
			}
		/>
	);
};

export default IsOwnExpensesCell;
